import { BASE_ENDPOINT } from "../../../endpoint";

export const addCollateralService = async (token: string, loanId: string, payload: any) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/loanmanagement/loan/${loanId}/collateral`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: payload
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
